import React, { useState, Fragment } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  Popover,
} from "@material-ui/core";
import { get, size } from "lodash";
import { AttachFileOutlined } from "@material-ui/icons";
import { IconLinkImg, NoAttachmentIcon } from "src/assets/";
import { defaultAttachmentImage } from "src/utils";
import LinkImg from "Assets/images/file-type/other-types.svg";
import { useStyles } from "./styles";
import Scrollbars from "react-custom-scrollbars";
import { saveAs } from "file-saver";

const RequestFeedbackAttachments = ({ attachmentData, isDownload }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const download = async (url, name) => {
    let imgName = name;
    let blob = await fetch(url).then((r) =>
      r.blob().catch((err) => {
        console.log("error:", err);
      })
    );
    saveAs(blob, imgName);
  };

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const open = Boolean(anchorEl);
  // "transitions-popper"
  const id = open ? "simple-popover" : undefined;
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box>
      <Button
        className={classes.attachmentIcon}
        aria-describedby={id}
        type="button"
        data-testid="iconClick"
        onClick={handleClick}
      >
        <AttachFileOutlined color="primary" />
        <span className={classes.attachmentCount}>{size(attachmentData)}</span>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        className={classes.popper}
        onClose={handleClose}
        placement="bottom-end"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          px={1.5}
          pb={0.5}
          mt={1}
          className={classes.borderBottom}
        >
          <Typography variant="subtitle2" className="font-semibold font-13">
            Attachments
          </Typography>
        </Box>
        {attachmentData?.length > 0 ? (
          <Scrollbars autoHeight autoHeightMax="125px">
            <Box px={1.5}>
              <ul className={classes.attachmentList}>
                {attachmentData.map((attachment) => {
                  let name = get(attachment, "fileName", "");

                  const type = defaultAttachmentImage(
                    get(attachment, "key", ""),
                    attachment
                  );

                  return (
                    <Fragment>
                      {attachment?.link && type?.attachmentType === "" ? (
                        <li>
                          <Link
                            className="truncate-txt cursor-pointer"
                            to={{
                              pathname: attachment?.link,
                            }}
                            target="_blank"
                          >
                            <Box display="flex" alignItems="center">
                              <Box
                                className={classes.thumbnailImg}
                                height="100%"
                                display="flex"
                              >
                                <img src={LinkImg} alt="thumbnail image" />
                              </Box>
                              <Typography
                                variant="body2"
                                noWrap="true"
                                className={classes.fileName}
                              >
                                {get(attachment, "link", "")}
                              </Typography>
                            </Box>
                          </Link>
                        </li>
                      ) : get(type, "attachmentType", "") !== "link" ? (
                        <li
                          className={`cursor-pointer`}
                          data-testid="download"
                          onClick={() =>
                            isDownload && download(attachment.url, name)
                          }
                        >
                          {/* <img
                                className="cursor-pointer"
                                onClick={() =>
                                  window.open(
                                    `${
                                      process.env.REACT_APP_CLOUD_FRONT_URL
                                    }/${get(attachment, "key", "")}`,
                                    "_blank"
                                  )
                                }
                                src={get(type, "selectedFileImage", "")}
                                alt="file icon"
                              /> */}
                          <img
                            src={
                              type?.attachmentType === "image"
                                ? `${
                                    process.env.REACT_APP_CLOUD_FRONT_URL
                                  }/${get(attachment, "key", "")}`
                                : get(type, "selectedFileImage", "")
                            }
                            alt="thumbnail image"
                          />
                          <span className="font-12 truncate-txt">{name}</span>
                        </li>
                      ) : (
                        <li>
                          <IconLinkImg />
                          <span className="font-12 truncate-txt">
                            <Link
                              to={{
                                pathname: get(type, "name", ""),
                              }}
                              target="_blank"
                            >
                              {get(type, "name", "")}
                            </Link>
                          </span>
                        </li>
                      )}
                    </Fragment>
                  );
                })}
              </ul>
            </Box>
          </Scrollbars>
        ) : (
          <Box textAlign="center" p={3}>
            <NoAttachmentIcon />
            <p className="f-light-gray">No attachment found</p>
          </Box>
        )}
      </Popover>
    </Box>
  );
};

export default RequestFeedbackAttachments;
